import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Locality, Road, lotRequest} from './locality.model';
import {Observable} from 'rxjs';
import {AppConfigService} from '../../common/service/app-config.service';
import {NgEventBus} from 'ng-event-bus';
import {forkJoinDefaultIfEmpty} from '../../common/observable.utils';

@Injectable({
    providedIn: 'root'
})
export class NlrpFieldRecordLocalitiesService {
    constructor(private http: HttpClient, private appConfigService:AppConfigService, private eventBus: NgEventBus) {}

    getAllLocalities(): Observable<Locality[]> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/locationname/findAllLocalities';
        return this.http.get<Locality[]>(url);
    }

    getRoadsByLocality(localityName: string) {
        const url = this.appConfigService.settings.apiGatewayUrl + '/locationname/findAllRoadsByLocality/' + localityName;
        return this.http.get<Road[]>(url);
    }

    getLotLocalitiesByLotRequestList(lotRequests: lotRequest[], resultSubject) {
        const subscription = forkJoinDefaultIfEmpty(lotRequests.map(lotRequest =>
            this.getLots(lotRequest.planType, lotRequest.planNumber, lotRequest.from, lotRequest.to))).subscribe(
            results => {
                const localities = results
                    .flatMap(lots => lots.map(lot => lot.locality))
                    .sort()
                    .filter(localityName => localityName)
                    .map(localityName => ({localityName}));

                const uniqueLocalities = [];
                const localitySet = new Set();

                localities.forEach(locality => {
                    if (!localitySet.has(locality.localityName)) {
                        localitySet.add(locality.localityName);
                        uniqueLocalities.push(locality);
                    }
                });

                resultSubject.next(uniqueLocalities);
                resultSubject.complete();
            }
        );
        this.eventBus.cast('nlr:busy', subscription);
    }

    getLots(planType: string, planNumber: number, fromLot: string, toLot: string): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/lots/' + planType + '/' + planNumber + '/' + (fromLot || -1) + '/' + (toLot || -1) + '/custom';
        return this.http.get<any>(url);
    }

    getSanitizedLocalities(localities) {
        if (localities) {
            const result = localities.filter(locality => {
                if (locality.localityName && locality.localityName !== '') {
                    return locality.localityName;
                }
            });
            return result.length > 0 ? true : false;
        } else {
            return false;
        }
    }
}
